import makeBookingsServiceRequest from '../utils/makeBookingServiceRequest';
import { BOOKING_C2_ENDPOINT_PREFIX } from '../constants/endpoints';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import type { GetBusinessInfoRequest, GetBusinessInfoResponse } from './schema/getBusinessInfo';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * BASELINE. DO NOT COPY AND PASTE.
 *	> 'js-cookie' import is restricted from being used. The long term plan is to deprecate the cookie so we should only be using this sparingly */
import jsCookie from 'js-cookie';
import {
    USER_CLIENT_ID_COOKIE_NAME,
    USER_CLIENT_ID_COOKIE_EXPIRY,
} from '../constants/cookieConstants';
import { getClientId } from 'owa-config';

const BrowserCookies: Cookies.CookiesStatic = jsCookie;

const ANONYMOUS_USER_ID_HEADER_NAME: string = 'Anonymous-User-Id';

export const getBusinessInfo = async (
    request: GetBusinessInfoRequest,
    beServer?: string
): Promise<GetBusinessInfoResponse | null> => {
    const perfDatapoint = new PerformanceDatapoint('getBusinessInfo');

    try {
        const { smtpAddress, isAuthRequired } = request;

        let userClientId = getClientId();
        const requestHeaders = new Headers();
        if (!!userClientId) {
            requestHeaders.append(ANONYMOUS_USER_ID_HEADER_NAME, userClientId);
        }

        //Adding BE server to the request headers
        requestHeaders.append('BEServerFqdn', beServer ?? '');

        const res = await makeBookingsServiceRequest({
            endpointPrefix: BOOKING_C2_ENDPOINT_PREFIX,
            smtpAddress,
            action: '',
            returnFullResponseOnSuccess: true,
            isAuthRequired,
            bwmHeader: true,
            queryString: '',
            requestHeaders,
        });
        const response = await res.json();

        //Logging user client id from headers
        userClientId = res.headers?.get('anonymous-user-id') ?? '';

        if (!userClientId) {
            //Add cookie
            BrowserCookies.set(USER_CLIENT_ID_COOKIE_NAME, userClientId ?? '', {
                expires: USER_CLIENT_ID_COOKIE_EXPIRY,
            });
        }

        response.clientId = userClientId;

        //logging mailbox puid from headers
        response.mailboxPuid = res.headers?.get('Mailboxpuid') ?? '';

        if (res.ok) {
            perfDatapoint.addCustomData({
                entryPoint: 'booking',
            });
            perfDatapoint.end();
            return response;
        } else {
            const { message, code, details, error } = response;
            perfDatapoint.addCustomData({
                entryPoint: 'booking',
                exceptionName: message,
                responseCode: code,
                responseDetails: JSON.stringify(details),
                responseError: error,
            });
            perfDatapoint.endWithError(DatapointStatus.ServerError);
            return response;
        }
    } catch (error) {
        perfDatapoint.endWithError(DatapointStatus.ServerError);
        return error;
    }
};

export default getBusinessInfo;
